import React from 'react'

const HomePage = () => {
    return (
        <>
            <div>Hello World</div>
        </>
    )
}

export default HomePage;